import { useMemo } from "react";

import { useQueryWithResponseHandler } from "@/hooks";

import { GetChangelogs } from "./queries.graphql";

interface UseChangelogProps {
  pageNumber?: number;
  pageSize?: number;
}

export const useChangelog = (props: UseChangelogProps = {}) => {
  const { pageNumber, pageSize } = props;

  const { state, data, error } = useQueryWithResponseHandler(
    {
      query: GetChangelogs,
      variables: {
        input: {
          pageNumber,
          pageSize,
        },
      },
    },
    {
      showSnackbarOnError: false, // fail silently
    },
  );

  return useMemo(() => {
    if (data?.changelogs?.__typename === "ChangelogsResult") {
      return {
        loading: state.fetching,
        error,
        changelogs: data?.changelogs?.changelogs,
      };
    }

    return { loading: state.fetching, error };
  }, [data, error, state.fetching]);
};
